export default __webpack_public_path__ + "static/media/giveo_explainer.23afbdf6.mp4";